import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/api";

export default function ProcurementVendorList() {
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    try {
      setLoading(true);

      const res = await api.get(
        "/vendors/procurement-vendors"
      );

      console.log("PROCUREMENT:", res);

      setRows(Array.isArray(res) ? res : []);
    } catch (err) {
      console.error(err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">

      {/* Header */}
      <div className="flex items-center justify-between mb-6">

        <div>
          <h1 className="text-2xl font-bold text-sap-text">
            Procurement Vendors
          </h1>

          <p className="text-sm text-gray-500">
            Vendor Risk Management / Procurement Failures
          </p>
        </div>

        <button
          onClick={() => navigate(-1)}
          className="px-4 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 transition"
        >
          ← Back
        </button>

      </div>

      {/* Total Count */}
      <div className="mb-3 text-sm text-gray-500">
        Total Vendors : <b>{rows.length}</b>
      </div>

      {/* Table */}
      <div className="bg-white rounded-lg shadow border overflow-auto">

        <table className="w-full">

          <thead>

            <tr className="border-b bg-gray-100">

              <th className="p-3 text-left">
                Vendor
              </th>

              <th className="p-3 text-right">
                Procurement Score
              </th>

              <th className="p-3 text-right">
                PO Count
              </th>

              <th className="p-3 text-right">
                GRPO Count
              </th>

              <th className="p-3 text-right">
                Invoice Count
              </th>

              <th className="p-3 text-right">
                Failure %
              </th>

              <th className="p-3 text-center">
                Risk
              </th>

            </tr>

          </thead>

          <tbody>

            {loading ? (

              <tr>
                <td
                  colSpan="7"
                  className="p-4 text-center"
                >
                  Loading...
                </td>
              </tr>

            ) : rows.length === 0 ? (

              <tr>
                <td
                  colSpan="7"
                  className="p-4 text-center"
                >
                  No Records Found
                </td>
              </tr>

            ) : (

              rows.map((row, idx) => (

                <tr
                  key={idx}
                  className="border-b hover:bg-gray-50"
                >

                  <td className="p-3">
                    {row["Vendor Name"]}
                  </td>

                  <td className="p-3 text-right">
                    {Number(
                      row.Procurement_Score || 0
                    ).toFixed(2)}
                  </td>

                  <td className="p-3 text-right">
                    {row.PO_Count || 0}
                  </td>

                  <td className="p-3 text-right">
                    {row.GRPO_Count || 0}
                  </td>

                  <td className="p-3 text-right">
                    {row.Invoice_Count || 0}
                  </td>

                  <td className="p-3 text-right">
                    {Number(
                      row.Procurement_Failure_Percentage || 0
                    ).toFixed(2)}
                    %
                  </td>

                  <td className="p-3 text-center">
                    {row.Risk_Level}
                  </td>

                </tr>

              ))

            )}

          </tbody>

        </table>

      </div>

    </div>
  );
}